export const CardData = [
  {
    id: 0,
    title: "Designed to Revolutionize Design Processes",
    caption: " Ability to create spheres, cubes, rectangular boxes, and cones",
    type: "card_1",
  },
  {
    id: 1,
    title: "Engineered for Enhanced Precision and Accuracy",
    caption: " Ability to create spheres, cubes, rectangular boxes, and cones",
    type: "card_2",
  },
  {
    id: 2,
    title: "Built to Expand Advanced Functionalities",
    caption: " Ability to create spheres, cubes, rectangular boxes, and cones",
    type: "card_3",
  },
];
